package smartTcm.containers


import com.jingfangpai.api.clients.MedicalRecordApiClient
import com.jingfangpai.api.clients.SignSymptomApiClient
import react.*
import react.dom.div
import setTitle
import smartTcm.components.SmartTcmWaitingArea

interface SmartTcmWaitingAreaPageProps : RProps {

}

data class SmartTcmIndexPageContextData(
    var getWaitingList:( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.MedicalRecord>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var save:(medicalRecord:com.jingfangpai.common.orm.mapping.MedicalRecord, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecord>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
    )

val SmartTcmWaitingAreaPageContext = createContext(SmartTcmIndexPageContextData(MedicalRecordApiClient::getWaitingList,MedicalRecordApiClient::save))

val SmartTcmWaitingAreaPageProvider = functionalComponent<SmartTcmWaitingAreaPageProps> { props ->

    setTitle("候诊区")

    fun placeHolderFunction(param: String) {
        console.log("doing something with param")
    }

    useEffectOnce { }

    SmartTcmWaitingAreaPageContext.Provider(SmartTcmIndexPageContextData(MedicalRecordApiClient::getWaitingList,MedicalRecordApiClient::save)) {
        div("SmartTcmIndexPage-page") {
            child(SmartTcmWaitingArea) {

            }
        }
    }
}
